import { render, staticRenderFns } from "./AdminAgreement.vue?vue&type=template&id=7a37ae67&scoped=true&v-if=loaded&"
import script from "./AdminAgreement.vue?vue&type=script&lang=ts&"
export * from "./AdminAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAgreement.vue?vue&type=style&index=0&id=7a37ae67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a37ae67",
  null
  
)

export default component.exports